<template>
  <div ref="dashboardRef" class="wrapper management-layout">
    <nav v-if="newAdminPortalConfig.useOldAdmin" class="main-header navbar navbar-expand 'navbar-light' flex-responsive p-0">
      <div class="banner cursor-pointer" @click="useNewAdminPortal">
        <div class="message-banner">
          This portal has reached end-of-life and is no longer actively maintained.
          <div class="d-inline-block support-end-date">
            <span style="text-decoration: underline" class="font-weight-700">Upgrade Admin Portal</span> by {{ newAdminPortalConfig.oldAdminEndTime }}
          </div>
        </div>
      </div>
    </nav>
    <nav id="dashboard-main-header" class="main-header navbar navbar-expand 'navbar-light' flex-responsive">
      <ul class="navbar-nav">
        <li class="nav-item pl-2 mr-4">
          <b-icon class="nav-link p-0" font-scale="1.8" icon="layout-sidebar" role="button"
                  @click="toggleMenuSidebar"></b-icon>
        </li>
        <li class="nav-item">
          <LanguageSwitcher  :show-label="false" :light-theme="false" :lang="language"></LanguageSwitcher>
        </li>
<!--        <li v-for="nav in activeSectionHeaderNavItems" class="header-nav-item nav-item d-none d-sm-inline-block">-->
<!--          <router-link :to="{name: nav.toPageName}" class="nav-link" exact exact-active-class="active">{{ nav.name }}</router-link>-->
<!--        </li>-->
      </ul>
      <ul class="navbar-right-menus navbar-nav ml-auto top-nav-btns">
        <!-- <li class="nav-item">
          <router-link class="btn btn-primary" to="/user/main">
            User Preview &nbsp;<b-icon class="pl-2" font-scale="1.6" icon="eye"></b-icon>
          </router-link>
        </li> -->
        <!-- <li class="nav-item">
        <b-button @click="updateProfileRedirect">
          <b-icon font-scale="1.8" icon="gear-fill"></b-icon>
        </b-button>
      </li> -->
        <li class="nav-item d-flex align-items-center" v-if="subscription.allow_upgrade">
          <button class="btn btn-primary" @click="upgradePlan">Upgrade Plan</button>
        </li>
        <li class="nav-item d-flex align-items-center">
          <HeaderDropdown :isAdminPage="true"/>
        </li>
      </ul>
    </nav>
    <Sidebar/>

    <div class="content-wrapper">
      <section class="content pt-4 py-4 px-4 pl-4 disable-scroll">
        <template v-if="showPopup"><Popup /></template>
        <router-view></router-view>
      </section>
    </div>
    <div v-if="uiValues.screenSize === 'xs' && uiValues.menuSidebarCollapsed" id="sidebar-overlay"
         @click="toggleMenuSidebar"></div>

    <div class="modal-container" v-if="showModal">
      <div class="modal-overlay" @click="acceptOffer"></div>
      <div class="modal-content">
        <img @click="acceptOffer" src="../assets/images/pop-up-trial.png" alt="Offer image">
      </div>
    </div>
    <UpgradeAccountPopup
        :is-open="!!askedForUpgradeAccountPopup"
        :on-cancel-return="onCancelUpgradeAccountReturn"
        @onVerified="hideUpgradeAccountPopup"
        @onCancel="hideUpgradeAccountPopup"/>
  </div>
</template>
<script>
import {mapState, createNamespacedHelpers} from "vuex";
import Sidebar from "@/module_dashboard/components/Sidebar/Sidebar";
import Popup from "@/module_b2b_users/views/Popup.vue";
import {calculateWindowSize} from "@/module_dashboard/store/layout";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import HeaderDropdown from "@/components/HeaderDropdown.vue";
import {permissionsMixin} from "@/utils/accessPermission.js"
import UpgradeAccountPopup from "@/module_dashboard/components/AdminUpgradeAccount.vue";
import moment from "moment";

const {
  mapState: layoutState,
  mapMutations: layoutMutations,
} = createNamespacedHelpers("dashboard/layout");
const {
  mapMutations: mapThemeMutations
} = createNamespacedHelpers("themes");

export default {
  components: {
    LanguageSwitcher,
    Sidebar,
    Popup,
    HeaderDropdown,
    UpgradeAccountPopup
  },
  mixins: [permissionsMixin],
  data() {
    return {
      appElement: null,
      // showOfferModal: localStorage.getItem("showOfferModal") === 'true',
      showOfferModal: false, // disabled
      showModal: false,
      showModalVideo: false,
      lang: 'en',
      showPopup: false
    }
  },
  computed: {
    ...layoutState(['menuSidebarCollapsed', 'screenSize', 'activeSectionHeaderNavItems']),
    ...mapState(['userInfo']),
    askedForUpgradeAccountPopup() {
      return this.$store.state.showAccessOptions;
    },
    onCancelUpgradeAccountReturn() {
      return this.askedForUpgradeAccountPopup?.onCancelReturn ?? true;
    },
    uiValues() {
      return {
        menuSidebarCollapsed: this.menuSidebarCollapsed,
        screenSize: this.screenSize,
      }
    },
    newAdminPortalConfig() {
      const config = this.$store.state.userInfo?.corporate?.config || {};
      return {
        useOldAdmin: !!config.useOldAdmin,
        oldAdminEndTime: config.oldAdminEndTime ? moment(config.oldAdminEndTime).format("MMMM Do"):null,
      }
    },
    corporateTheme() {
      return this.$store.state?.userInfo?.corporate?.theme;
    },
    subscription() {
      const subs = this.$store.state?.userInfo?.corporate?.subscription || {};
      const is_valid = subs.is_valid === true && (subs.is_free === false);
      return {
        allow_upgrade: is_valid && subs.allow_upgrade,
        allow_video_upload: is_valid && subs.allow_video_upload
      };
    },
    language() {
      const savedLanguage = localStorage.getItem('lang');
      if (savedLanguage) {
        return savedLanguage;
      }
      return this.$store.state?.userInfo?.corporate?.config?.loginConfig?.language || 'en';
    },
    // showLanguageDropdown() {
    //   const defaultLanguage = this.$store.state?.userInfo?.corporate?.config?.loginConfig?.language || 'en';
    //   return defaultLanguage !== 'en';
    // },
  },
  watch: {
    uiValues() {
      this.onUIValuesChange();
    }
  },
  methods: {
    ...layoutMutations(['toggleMenuSidebar', 'setWindowSize']),
    ...mapThemeMutations(['setTheme']),
    hideUpgradeAccountPopup() {
      this.$store.commit('setShowAccessOptions', false);
    },
    async useNewAdminPortal() {
      localStorage.setItem("useNewAdminPortal", true);
      this.$store.dispatch('goToAdminPortal', {newAdminPortal: "true"});
    },
    onUIValuesChange() {
      if (!this.appElement) return;

      this.appElement.classList.remove('sidebar-closed');
      this.appElement.classList.remove('sidebar-collapse');
      this.appElement.classList.remove('sidebar-open');

      if (this.menuSidebarCollapsed && this.screenSize === 'lg') {
        this.appElement.classList.add('sidebar-collapse');
      } else if (this.menuSidebarCollapsed && this.screenSize === 'xs') {
        this.appElement.classList.add('sidebar-open');
      } else if (!this.menuSidebarCollapsed && this.screenSize !== 'lg') {
        this.appElement.classList.add('sidebar-closed');
        this.appElement.classList.add('sidebar-collapse');
      }
    },
    upgradePlan() {
      this.$store.commit('setShowAccessOptions', {
        onCancelReturn: false
      });
    },
    acceptOffer() {
      this.showModal = false;
      this.showOfferModal = false;
      localStorage.setItem("showOfferModal", "false");
      if (this.showModalVideo) {
        this.showModalVideo = false;
        this.$router.push("/management/conditions");
      }
    },
    openModalAndVideo() {
      this.showModal = true;
      this.showModalVideo = true;
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        console.log('🔵 Tab is now visible');
        this.$store.dispatch('loadUserDetails')
      } else {
        console.log('⚪ Tab is hidden');
      }
    }
  },
  mounted() {
    this.setTheme(this.corporateTheme);
    //Set language
    if(this.$route.path.includes('/assessment') && !this.userInfo?.corporate?.config?.is_assessment){
      this.showPopup = true;
    }
    this.lang = this.language;
    this.appElement = this.$refs.dashboardRef;
    this.appElement.classList.add('sidebar-mini');
    this.appElement.classList.add('layout-fixed');
    this.onUIValuesChange();
    window.addEventListener('resize', _ => {
      this.setWindowSize(calculateWindowSize(window.innerWidth));
    })

    window.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    this.appElement.classList.remove('sidebar-mini');
    this.appElement.classList.remove('layout-fixed');
    window.removeEventListener('resize', _ => {
      this.setWindowSize(calculateWindowSize(window.innerWidth));
    })
    window.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>
<style lang="scss" scoped>
@import "@/module_dashboard/styles/admin_lte.scss";

.layout-fixed .main-sidebar {
  position: fixed !important;
}

.navbar-right-menus {
  justify-content: end;

  li {
    padding-left: 8px;
    font-size: 16px !important;
    line-height: 24px !important;
    font-weight: 700 !important;
    color: #FFFFFF !important;
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: space-between;

    text-decoration: none !important;
    border: none;
    box-shadow: 0px 16px 49px rgb(20 21 19 / 15%);
    border-radius: 18px;
    box-shadow: none;
    background-color: #73bc44;
    padding: 6px 12px;
    text-align: center;
    white-space: nowrap;
    font-weight: 700 !important;
    height: 36px;
  }
}

@media screen and (max-width: 768px) {
  .flex-responsive{
      flex-wrap: wrap !important;
  }

  .disable-scroll{
    overflow-x: hidden;
  }

}


.header-nav-item.nav-item>.nav-link {
  color: #969B92 !important;
  font-weight: bolder;
}

.header-nav-item.nav-item>.nav-link.active {
  color: #73bc44 !important;
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-content {
  background-color: #fff;
  padding: 0;
  max-width: 650px;
  cursor: pointer;
}

/* Optional styling for the modal content */
.modal-content h2 {
  margin-top: 0;
}


::v-deep .profile-img .dropdown-menu.show {
  background-color: white !important;
}

::v-deep .profile-img .dropdown .nav-link {
  color: #73bc44 !important;
}

::v-deep .profile-img .dropdown span {
  color: #141513 !important;
}

::v-deep .nav-wrapper .nav-link:hover {
  color: #73bc44;
}

::v-deep .nav-wrapper .nav-link.active {
  color: #73bc44;

  .home {
    svg {
      path {
        fill: #73bc44 !important;
        fill-rule: "evenodd";
        clip-rule: "evenodd";
        stroke-width: 0;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .leaderboard {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .progress-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .social-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }
  }
}

::v-deep .nav-wrapper .nav-link {
  color: #969b92;

  //background-color: #141513;
  .home {
    .menu-text {
      font-weight: 500;
    }
  }

  .leaderboard {
    .menu-text {
      font-weight: 500;
    }
  }

  .progress-tab {
    .menu-text {
      font-weight: 500;
    }
  }
}

::v-deep .profile-img .dropdown .dropdown-item {
  color: #73bc44 !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  background-color: white !important;
}

::v-deep .profile-img .dropdown-toggle {
  color: #73bc44 !important;
}
::v-deep .navbar-nav {
  align-items: center;
}
.banner {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  text-align: center;
  background-color: #ffb731;

  .support-end-date {
    font-weight: 500;
    border-radius: 14px;
  }
}
</style>
